import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Navbar from '../../Components/Navbar/Navbar';

function ProductDetails() {
    const { productId } = useParams();
    const [product, setProduct] = useState({});
    const [transactions, setTransactions] = useState({
        dateOfPay: '',
        nameofbuyer: '',
        unitsSold: '',
        mobileNumber: '',
        clientId: '',
        numberOfUnits: '',
        amountpaid: '',
        balance: ''
    });
    const [initialProduct, setInitialProduct] = useState({});
    const [isChanged, setIsChanged] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [formFile, setFormFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [formPreview, setFormPreview] = useState('');

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(
                    `https://portal-sanieldanproperties-api.onrender.com/admin/${productId}`
                );
                if (response.data) {
                    setProduct(response.data);
                    setInitialProduct(response.data);
                    setImagePreview(response.data.productimage);
                    setFormPreview(response.data.productformfile);
                } else {
                    console.error('Product not found');
                }
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };

        fetchProduct();
    }, [productId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProduct({ ...product, [name]: value });
        checkForChanges({ ...product, [name]: value });
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
            if (type === 'image') {
                setImageFile(file);
                setImagePreview(URL.createObjectURL(file));
            } else {
                setFormFile(file);
                setFormPreview(URL.createObjectURL(file));
            }
            checkForChanges({ ...product });
        }
    };

    const checkForChanges = (updatedProduct) => {
        const hasChanges = 
            updatedProduct.producttitle !== initialProduct.producttitle ||
            updatedProduct.productdescription !== initialProduct.productdescription ||
            updatedProduct.productprice !== initialProduct.productprice ||
            updatedProduct.productunitssold !== initialProduct.productunitssold ||
            updatedProduct.productunitsleft !== initialProduct.productunitsleft ||
            updatedProduct.productlocation !== initialProduct.productlocation ||
            updatedProduct.directcommission !== initialProduct.directcommission ||
            updatedProduct.inDirectcommission !== initialProduct.inDirectcommission ||
            imageFile !== null ||
            formFile !== null;

        setIsChanged(hasChanges);
    };

    const uploadToCloudinary = async (file, type) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'giweexpv');
        
        try {
            const response = await axios.post(
                'https://api.cloudinary.com/v1_1/dwpoik1jm/upload', 
                formData
            );
            return response.data.secure_url;
        } catch (error) {
            console.error(`Error uploading ${type}:`, error);
            throw error;
        }
    };

    const updateProduct = async () => {
        setIsLoading(true);
        try {
            let productImageUrl = product.productimage;
            let productFormUrl = product.productformfile;

            // Upload new files if they exist
            if (imageFile) {
                productImageUrl = await uploadToCloudinary(imageFile, 'image');
            }
            if (formFile) {
                productFormUrl = await uploadToCloudinary(formFile, 'form');
            }

            const updatedData = {
                producttitle: product.producttitle,
                productdescription: product.productdescription,
                productprice: product.productprice,
                productunitssold: product.productunitssold,
                productunitsleft: product.productunitsleft,
                productlocation: product.productlocation,
                directcommission: product.directcommission,
                inDirectcommission: product.inDirectcommission,
                productimage: productImageUrl,
                productformfile: productFormUrl
            };

            await axios.put(
                `https://portal-sanieldanproperties-api.onrender.com/admin/update-product/${productId}`,
                updatedData
            );

            setInitialProduct(product);
            setImageFile(null);
            setFormFile(null);
            setIsChanged(false);
            setSuccess(`${product.producttitle} Product data updated successfully!`);

            setTimeout(() => {
                setSuccess('');
            }, 5000);
        } catch (error) {
            setError(error.response?.data?.error || 'Failed to update product');
            setTimeout(() => {
                setError('');
            }, 5000);
        } finally {
            setIsLoading(false);
        }
    };

    const AddTransactions = async () => {
        try {
            const AddTransactionsData = {
                dateOfPay: transactions.dateOfPay,
                nameofbuyer: transactions.nameofbuyer,
                unitsSold: transactions.unitsSold,
                mobileNumber: transactions.mobileNumber,
                clientId: transactions.clientId,
                numberOfUnits: transactions.numberOfUnits,
                amountpaid: transactions.amountpaid,
                balance: transactions.balance
            };

            await axios.post(
                `https://portal-sanieldanproperties-api.onrender.com/admin/add-transaction/${productId}`,
                AddTransactionsData
            );

            setSuccess("Transaction added successfully!");
            setTransactions({
                dateOfPay: '',
                nameofbuyer: '',
                unitsSold: '',
                mobileNumber: '',
                clientId: '',
                numberOfUnits: '',
                amountpaid: '',
                balance: ''
            });

            setTimeout(() => {
                setSuccess('');
            }, 5000);
        } catch (error) {
            setError(error.response?.data?.error || 'Failed to add transaction');
            setTimeout(() => {
                setError('');
            }, 5000);
        }
    };

    return (
        <div className="details bg-gray-50 min-h-screen">
            <div className="">
                <Sidebar />
            </div>

            <div className="detail_page_main">
                <Navbar />

                {/* Notifications */}
                {error && (
                    <div className="fixed top-20 right-4 z-50 max-w-sm">
                        <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg shadow-lg">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700 font-medium">Update Failed</p>
                                    <p className="text-sm text-red-600">{error}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {success && (
                    <div className="fixed top-20 right-4 z-50 max-w-sm">
                        <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg shadow-lg">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-green-700 font-medium">Success</p>
                                    <p className="text-sm text-green-600">{success}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="p-6">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        {/* Product Overview Card */}
                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-xl shadow-lg p-6">
                                <h2 className="text-2xl font-bold text-gray-800 mb-4">Product Overview</h2>
                                
                                {/* Product Image */}
                                <div className="mb-4">
                                    <img 
                                        src={imagePreview} 
                                        alt="product" 
                                        className="w-full h-64 object-cover rounded-lg shadow-md"
                                    />
                                </div>

                                {/* Product Form */}
                                <div className="mb-6">
                                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Product Form</h3>
                                    <img 
                                        src={formPreview} 
                                        alt="product form" 
                                        className="w-full h-64 object-cover rounded-lg shadow-md"
                                    />
                                </div>

                                <div className="space-y-3">
                                    <div className="flex justify-between items-center py-2 border-b">
                                        <span className="font-medium text-gray-600">Title:</span>
                                        <span className="text-gray-800">{product.producttitle}</span>
                                    </div>
                                    <div className="flex justify-between items-center py-2 border-b">
                                        <span className="font-medium text-gray-600">Price:</span>
                                        <span className="text-green-600 font-semibold">₦ {Number(product.productprice).toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between items-center py-2 border-b">
                                        <span className="font-medium text-gray-600">Units Sold:</span>
                                        <span className="text-blue-600">{product.productunitssold}</span>
                                    </div>
                                    <div className="flex justify-between items-center py-2 border-b">
                                        <span className="font-medium text-gray-600">Units Remaining:</span>
                                        <span className="text-orange-600">{product.productunitsleft}</span>
                                    </div>
                                    <div className="flex justify-between items-center py-2 border-b">
                                        <span className="font-medium text-gray-600">Location:</span>
                                        <span className="text-gray-800">{product.productlocation}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Edit Product Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                                <h1 className="text-2xl font-bold text-gray-800 mb-6">Edit Product Details</h1>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                   
                                  

                                    {/* Product Details Form */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Product Title
                                        </label>
                                        <input 
                                            type="text" 
                                            name="producttitle"
                                            value={product.producttitle || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Product Price
                                        </label>
                                        <input 
                                            type="text" 
                                            name="productprice"
                                            value={product.productprice || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Units Sold
                                        </label>
                                        <input 
                                            type="text" 
                                            name="productunitssold"
                                            value={product.productunitssold || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Units Remaining
                                        </label>
                                        <input 
                                            type="text" 
                                            name="productunitsleft"
                                            value={product.productunitsleft || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Location
                                        </label>
                                        <input 
                                            type="text" 
                                            name="productlocation"
                                            value={product.productlocation || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Direct Commission
                                        </label>
                                        <input 
                                            type="text" 
                                            name="directcommission"
                                            value={product.directcommission || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Indirect Commission
                                        </label>
                                        <input 
                                            type="text" 
                                            name="inDirectcommission"
                                            value={product.inDirectcommission || ''}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Product Description
                                        </label>
                                        <textarea 
                                            name="productdescription"
                                            value={product.productdescription || ''}
                                            onChange={handleInputChange}
                                            rows="4"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                </div>

                                <div className="mt-6">
                                    <button
                                        onClick={updateProduct}
                                        disabled={!isChanged || isLoading}
                                        className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${
                                            isChanged && !isLoading 
                                                ? "bg-blue-600 hover:bg-blue-700 text-white shadow-lg" 
                                                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                        }`}
                                    >
                                        {isLoading ? (
                                            <div className="flex items-center justify-center">
                                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Updating...
                                            </div>
                                        ) : (
                                            'Save Changes'
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Add Transactions Form */}
                            <div className="bg-white rounded-xl shadow-lg p-6">
                                <h1 className="text-2xl font-bold text-gray-800 mb-6">Add Transaction</h1>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Date of Payment
                                        </label>
                                        <input 
                                            type="date" 
                                            name="dateOfPay"
                                            value={transactions.dateOfPay}
                                            onChange={(e) => setTransactions({ ...transactions, dateOfPay: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Buyer Name
                                        </label>
                                        <input 
                                            type="text" 
                                            name="nameofbuyer"
                                            value={transactions.nameofbuyer}
                                            onChange={(e) => setTransactions({ ...transactions, nameofbuyer: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Units Sold
                                        </label>
                                        <input 
                                            type="number" 
                                            name="unitsSold"
                                            value={transactions.unitsSold}
                                            onChange={(e) => setTransactions({ ...transactions, unitsSold: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Mobile Number
                                        </label>
                                        <input 
                                            type="text" 
                                            name="mobileNumber"
                                            value={transactions.mobileNumber}
                                            onChange={(e) => setTransactions({ ...transactions, mobileNumber: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Client ID
                                        </label>
                                        <input 
                                            type="text" 
                                            name="clientId"
                                            value={transactions.clientId}
                                            onChange={(e) => setTransactions({ ...transactions, clientId: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Number of Units
                                        </label>
                                        <input 
                                            type="number" 
                                            name="numberOfUnits"
                                            value={transactions.numberOfUnits}
                                            onChange={(e) => setTransactions({ ...transactions, numberOfUnits: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Amount Paid
                                        </label>
                                        <input 
                                            type="number" 
                                            name="amountpaid"
                                            value={transactions.amountpaid}
                                            onChange={(e) => setTransactions({ ...transactions, amountpaid: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Balance
                                        </label>
                                        <input 
                                            type="number" 
                                            name="balance"
                                            value={transactions.balance}
                                            onChange={(e) => setTransactions({ ...transactions, balance: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                </div>

                                <div className="mt-6">
                                    <button
                                        onClick={AddTransactions}
                                        className="w-full py-3 px-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg shadow-lg transition-colors"
                                    >
                                        Add Transaction
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductDetails;
